import React from "react";
import {
  Box,
  Container,
  Typography,
} from "@mui/material";

const shippingPrices = [
  "בירושלים מעל 600 שקל – משלוח חינם",

  "בירושלים בקנייה בין 300 ל־600 שקל – עלות המשלוח 35 שקל",

  "גילה, גבעת זאב, הר חומה ותלפיות בקנייה מעל 600 שקל – עלות המשלוח 25 שקל",

  "גילה, גבעת זאב, הר חומה ותלפיות בקנייה בין 300 ל־600 שקל – עלות המשלוח 50 שקל",

  "תל ציון, טלסטון ומעלה אדומים בקנייה מעל 600 שקל – עלות המשלוח 35 שקל",

  "תל ציון, טלסטון ומעלה אדומים בקנייה בין 300 ל־600 שקל – עלות המשלוח 50 שקל",
];

export default function ShippingPolicy() {
  return (
    <Box
      component="main"
      dir="rtl"
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        overflowX: "hidden",
        boxSizing: "border-box",

        py: {
          xs: 2,
          sm: 3,
          md: 5,
        },
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          boxSizing: "border-box",

          px: {
            xs: 2,
            sm: 3,
          },
        }}
      >
        <Typography
          component="h1"
          sx={{
            mb: 2,
            color: "#D81B60",
            textAlign: "center",
            fontWeight: 800,

            fontSize: {
              xs: "1.65rem",
              sm: "2rem",
              md: "2.25rem",
            },
          }}
        >
          תקנון משלוחים
        </Typography>

        <Typography
          component="p"
          sx={{
            fontWeight: 800,
            textAlign: "center",
            lineHeight: 1.5,

            fontSize: {
              xs: "1.25rem",
              sm: "1.6rem",
              md: "2rem",
            },

            mb: {
              xs: 3,
              md: 4,
            },
          }}
        >
          כרגע המשלוחים הם בירושלים
          והסביבה בלבד
        </Typography>

        <Typography
          component="h2"
          sx={{
            mb: 2,
            fontWeight: 700,
            textAlign: "center",

            fontSize: {
              xs: "1.2rem",
              sm: "1.35rem",
              md: "1.5rem",
            },
          }}
        >
          מחירון משלוחים
        </Typography>

        <Box
          component="section"
          aria-label="מחירון משלוחים"
          sx={{
            width: "100%",
            maxWidth: 800,
            minWidth: 0,
            mx: "auto",

            display: "grid",

            gridTemplateColumns: {
              xs: "minmax(0, 1fr)",
              sm: "repeat(2, minmax(0, 1fr))",
            },

            border: "1px solid #424242",
            borderRadius: 2,
            overflow: "hidden",
            boxSizing: "border-box",

            mb: {
              xs: 3,
              md: 4,
            },
          }}
        >
          {shippingPrices.map(
            (text, index) => (
              <Box
                key={index}
                sx={{
                  minWidth: 0,

                  minHeight: {
                    xs: "auto",
                    sm: 130,
                  },

                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",

                  p: {
                    xs: 2,
                    sm: 2.5,
                  },

                  border: "1px solid #424242",
                  boxSizing: "border-box",

                  textAlign: "center",
                  lineHeight: 1.6,
                  overflowWrap: "anywhere",

                  fontSize: {
                    xs: "1rem",
                    sm: "1.05rem",
                    md: "1.125rem",
                  },
                }}
              >
                {text}
              </Box>
            )
          )}
        </Box>

        <Box
          component="section"
          aria-label="מידע נוסף על המשלוחים"
          sx={{
            width: "100%",
            maxWidth: 900,
            mx: "auto",
            textAlign: "center",
          }}
        >
          <Typography
            component="p"
            sx={informationTextStyle}
          >
            מחירי המוצרים המופיעים באתר
            אינם כוללים דמי משלוח
          </Typography>

          <Typography
            component="p"
            sx={informationTextStyle}
          >
            איסוף עצמי יתבצע לאחר תיאום עם
            נציג בחנות ואישור שההזמנה מוכנה
          </Typography>

          <Typography
            component="p"
            sx={{
              ...informationTextStyle,
              mb: 0,
            }}
          >
            המשלוח יסופק עד 7 ימי עסקים על
            ידי חברת שליחויות
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

const informationTextStyle = {
  mb: 1.5,
  fontWeight: 500,
  lineHeight: 1.7,
  overflowWrap: "anywhere",

  fontSize: {
    xs: "1rem",
    sm: "1.15rem",
    md: "1.35rem",
  },
};